import { h, render } from "preact";
import ProductSwatches from "./product-swatches";
import { readFamilySwatchData } from "../helpers/unwrapProducts";

class ProductFormSwatches extends HTMLElement {
  static observedAttributes = ["product-group", "product-family", "product-id"];

  constructor() {
    super();
  }

  connectedCallback() {
    this._render();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;
    if (!this.isConnected) return;

    this._render();
  }

  _render() {
    render(
      <ProductSwatches
        groupName={this.productGroup}
        familyIds={this.productFamily}
        familyData={this.productFamilyData}
        productId={this.productId}
        showLabels={this.showLabels}
        onlyActive={this.onlyActive}
      />,
      this
    );
  }

  get productGroup() {
    return this.getAttribute("product-group");
  }

  get productFamily() {
    return (this.getAttribute("product-family") || "")
      .split(",")
      .map((id) => id.trim())
      .filter(Boolean);
  }

  get productFamilyData() {
    return readFamilySwatchData(this.closest("product-form") || document);
  }

  get productId() {
    return this.getAttribute("product-id");
  }

  get showLabels() {
    return this.hasAttribute("show-labels");
  }

  get onlyActive() {
    return this.hasAttribute("only-active");
  }
}

if (!customElements.get("product-form-swatches")) {
  customElements.define("product-form-swatches", ProductFormSwatches);
}
